<template>
  <v-container grid-list-md fluid class="pt-0 pb-0">
    <v-card class="pa-2 card-r">
      <v-toolbar class="primary mb-2 darken-2 card-r shadow-1 pl-3 text-white">
        <v-btn icon to="/classes">
          <v-icon color="white">keyboard_arrow_left</v-icon>
        </v-btn>
        <!--<router-link to="/"><v-icon class="text-white left pr-3">keyboard_arrow_left</v-icon></router-link>-->
        <div class="text-xs-left f-20">Add Class</div>
      </v-toolbar>
      <v-card class="pa-2 no-shadow grey lighten-5">
            <v-layout row wrap>

            <v-flex xs12 lg3 class="hide-pro">
              <v-select
                solo
                v-model="classType"
                :items="types"
                item-text='text'
                item-value='value'
                class="input-group--focused"
                :label="$t('classes_page.add_class_page.fields.class_type')"
                type="text"
              ></v-select>
            </v-flex>
            <v-flex xs12 lg4 v-if="classType=='other'" class="hide-pro">
                <v-text-field solo v-model="otherType" :rules="requiredRule" label="Type Class type"></v-text-field>
            </v-flex>
            <v-flex xs12 lg4 class="hide-pro">
              <v-text-field solo :rules="requiredRule" v-model="classTitle" label="Class Title"></v-text-field>
            </v-flex>

            <v-flex xs12 lg3 class="hide-pro">
              <v-text-field
                solo v-model="classLocation" label="Class Location">
              </v-text-field>
            </v-flex>
              <v-flex xs12 lg2 class="hide-pro">
                <v-select
                  solo
                  v-model="classHours"
                  :items="workMin"
                  class="input-group--focused"
                  label="Minutes (Class Minutes can add here)"
                  type="number"
                ></v-select>
              </v-flex>
            <v-flex xs12 lg12 class="text-xs-left mb-3 ">
              <v-flex class="white shadow-1 hide-pro">
                <div class="text-xs-left text-primary ml-2 f-9">Description Tags</div>
                <treeselect solo class="" placeholder="Description" v-model="value" search-nested :always-open="false" :append-to-body="true" :multiple="true" :options="options" />
             </v-flex>
           </v-flex>


             <v-flex xs12 lg12 class="pt-0 pb-0 hide-pro">
              <v-textarea solo class="redius-5" name="input-7-1" v-model="classDescription" label="Description" ></v-textarea>
            </v-flex>

            <v-flex xs12 lg12 class="pt-0 pb-0 hide-pro">
              <v-textarea solo class="redius-5" name="input-7-1" v-model="sms_content" label="Sms" ></v-textarea>
            </v-flex>
              <v-flex xs12 lg12 class="pt-0 pb-0 hide-pro">
              <v-textarea solo class="redius-5" name="input-7-1" v-model="email_content" label="Email" ></v-textarea>
            </v-flex>

            <v-flex xs12 lg12 class="hide-pro">
               <v-checkbox class="pa-0 ma-0"
                  v-model="unlimitedTick"
                  :label="$t('classes_page.add_class_page.fields.tick')"
                ></v-checkbox>
            </v-flex>
            </v-layout>

          <v-flex xs12>
            <v-flex class="ma-2" v-for="url in attachment.galleryURL" :key="url" xs12>
              <v-card flat tile flex>
                <v-img
                  :src="url"
                  style="height: 100px; width: 100px !important;"
                  :lazy-src="url"
                  aspect-ratio="1"
                  class="grey lighten-2"
                />
                <v-layout>
                  <v-flex>
                    <div class="w-100 text-xs-left">
                       <v-btn small class="card-r text-xs-left ma-0" outline @click="onPickImg">Upload IMage</v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
              <v-layout wrap row>
                <v-flex class="br-2 ma-2 pl-3 pr-0 pb-3" v-for="url in attachment.galleryURL" :key="url" xs12>
                  <v-card flat tile flex>
                    <div class="w-100 text-xs-right">
                      <v-btn icon color="grey lighten-2"><v-icon>close</v-icon></v-btn>
                    </div>
                    <v-img
                      :src="url"
                      style="height: 100px; width: 100px !important;"
                      :lazy-src="url"
                      aspect-ratio="1"
                      class="grey lighten-2 h-150"
                    >
                      <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-layout>
                    </v-img>
                  </v-card>
                </v-flex>
              </v-layout>
            <v-layout row wrap>
              <v-flex xs12 class="text-xs-center">
                <v-alert
                  :value="true"
                  color="success"
                  icon="check_circle"
                  v-if="alert.type=='success'"
                  outline>
                  {{alert.msg}}
                </v-alert>
              </v-flex>
              <v-flex xs12 class="text-xs-center">
                <v-alert
                  :value="true"
                  color="error"
                  icon="warning"
                  v-if="alert.type=='warning'"
                  outline>
                  {{alert.msg}}
                </v-alert>
              </v-flex>
              <v-flex xs12 class="text-xs-center">
                <v-progress-circular
                  indeterminate
                  v-if=loading
                  color="primary"
                ></v-progress-circular>
              </v-flex>
              <v-flex xs12 class="text-xs-right">
                <v-btn color="primary darken-2 no-shadow card-r right" slot="activator" dark @click="AddModule()">Finish</v-btn>
              </v-flex>
            </v-layout>

          </v-flex>
        </v-card>
    </v-card>
  </v-container>
</template>
<script>
import ConfirmSignup from "../auth/ConfirmSignup";
import FormData from "form-data";
import api from '../../utils/backend-api.js'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {

  data: () => ({
    value:[],
    classTitle: "",
    classLocation: "",
    classHours: "",
    classType:"",
    classPrice: "",
    internalPrice: "",
    classDescription: "",

    attachment: {
      galleries: [],
      galleryURL: [],
      photosURL: [],
      videos: [],
      videosURL: [],
      e7: [],

    },
    requiredRule: [v => !!v || "This field is required"],
    workMin: ["45", "90", "135", "180","225","270","315","360"],
    types:[
        {text:'Teori',value:'teori'},
        {text:'Kørsel',value:'kørsel'},
        {text:'Manøvre',value:'manøvre'},
        {text:'Glatbane',value:'glatbane'},
        {text:'Other',value:'other'}
    ],
    otherType:'',
    states: [
          'Alabama', 'Alaska', 'American Samoa', 'Arizona'
    ],
    options: [],
    tagId:{
      parent:[],
      child:[],
      childOfChild:[]
    },
    loading:false,
    alert:{
      type:'',
      msg:''
    },
    unlimitedTick:false,
    datePickMenu:false,
    timePickMenu:false,
    classDate:'',
    classTime:'',
    timeslot: [
      {text:'07:00 am',value:'07:00'},
      {text:'07:30 am',value:'07:30'},
      {text:'08:00 am',value:'08:00'},
      {text:'08:30 am',value:'08:30'},
      {text:'09:00 am',value:'09:00'},
      {text:'09:30 am',value:'09:30'},
      {text:'10:00 am',value:'10:00'},
      {text:'10:30 am',value:'10:30'},
      {text:'11:00 am',value:'11:00'},
      {text:'11:30 am',value:'11:30'},
      {text:'12:00 pm',value:'12:00'},
      {text:'12:30 pm',value:'12:30'},
      {text:'01:00 pm',value:'13:00'},
      {text:'01:30 pm',value:'13:30'},
      {text:'02:00 pm',value:'14:00'},
      {text:'02:30 pm',value:'14:30'},
      {text:'03:00 pm',value:'15:00'},
      {text:'03:30 pm',value:'15:30'},
      {text:'04:00 pm',value:'16:00'},
      {text:'04:30 pm',value:'16:30'},
      {text:'05:00 pm',value:'17:00'},
      {text:'05:30 pm',value:'17:30'},
      {text:'06:00 pm',value:'18:00'},
      {text:'06:30 pm',value:'18:30'},
    ],
    email_content:'',
    sms_content:''

  }),
  watch: {},
  created() {
        api.postData('tag/viewTag')
        .then(res=>{
          this.options=res.data
          this.storeTagId(res.data)
        }).catch(err=>{

        })

        this.types=[
          {text:this.$t('classes_page.add_class_page.fields.class_type_values[0]'),value:'teori'},
          {text:this.$t('classes_page.add_class_page.fields.class_type_values[1]'),value:'kørsel'},
          {text:this.$t('classes_page.add_class_page.fields.class_type_values[2]'),value:'manøvre'},
          {text:this.$t('classes_page.add_class_page.fields.class_type_values[3]'),value:'glatbane'},
          {text:this.$t('classes_page.add_class_page.fields.class_type_values[4]'),value:'other'}
        ]
  },
  methods: {
    storeTagId(Tags){
        let parent=[]
        let child=[]
        let childOfChild=[]
        Tags.forEach(function(element,index){
          parent.push(element.id)
          if(Tags[index].children){
            let children=Tags[index].children
            children.forEach(function(elementC,indexC){
              child.push(children[indexC].id)

              if(Tags[index].children[indexC].children){
                // console.log(Tags[index].children[indexC].children)
                let childrenOfChild=Tags[index].children[indexC].children
                childrenOfChild.forEach(function(elementCC,indexCC){
                  childOfChild.push(childrenOfChild[indexCC].id)
                })
              }
            })
          }
        })
        this.tagId.parent=parent
        this.tagId.child=child
        this.tagId.childOfChild=childOfChild
    },
    print(){
        // console.log(this.value)
    },
    TagIdAnalyze(tagIdList){
      let oldParent=this.tagId.parent
      let oldChild=this.tagId.child
      let oldchildOfChild=this.tagId.childOfChild
      let finalParent=[]
      let finalChild=[]
      let finalChildOfChild=[]
      if(tagIdList){
          console.log("tagIdList")
          console.log(tagIdList)
          tagIdList.forEach(function(element,index){
            console.log(element)
            oldParent.forEach(function(elementP,indexP){
              // console.log(elementP)
                if(elementP==element){
                  finalParent.push(elementP)
                }
            })
            oldChild.forEach(function(elementC,indexC){
                if(elementC==element){
                  finalChild.push(elementC)
                }
            })
            oldchildOfChild.forEach(function(elementCC,indexCC){
                if(elementCC==element){
                  finalChildOfChild.push(elementCC)
                }
            })
          })
      }
      return {finalParent,finalChild,finalChildOfChild};
    },
    AddModule() {
      // console.log(this.attachment);
      // console.log(this.value)
      this.loading=true
      this.alert.type=""
      var FinalTagIdList={}
      var {finalParent,finalChild,finalChildOfChild}=this.TagIdAnalyze(this.value)
      var moduleDetails = {
        name: this.classTitle,
        location: this.classLocation,
        hours: this.classHours,
        type:this.classType,
        price: this.classPrice,
        internal_price: this.internalPrice,
        // image: this.attachment.galleries,
        parent:finalParent,
        child:finalChild,
        sub_child:finalChildOfChild,
        image_count:this.attachment.galleries.length,
        description:this.classDescription,
        email_content:this.email_content,
        sms_content:this.sms_content
        // time:this.classTime
      };
      for(var x=0;x<this.attachment.galleries.length;x++){
        moduleDetails['image'+x]=this.attachment.galleries[x]
      }
      let classType
      if(this.unlimitedTick==true){
          classType="unlimited"
      }else{
          classType="limited"
      }


      var formData = new FormData();
      formData.append("name", this.classTitle);
      formData.append("location", this.classLocation);
      formData.append("hours", this.classHours);
      formData.append("type", this.classType);
      if(this.classType=='other'){
        formData.append("other_type", this.otherType);
      }
      // formData.append("price", this.classPrice);
      // formData.append("internal_price", this.internalPrice);
      // if(this.classDate){
      //   formData.append("date", this.classDate);
      // }
      // if(this.classTime){
      //   formData.append("time", this.classTime);
      // }
      formData.append("description", this.classDescription);
      formData.append("booking_status", classType);
      formData.append("email_content", this.email_content);
      formData.append("sms_content", this.sms_content);
      // formData.append("parent[]", JSON.stringify(finalParent));
      if(finalParent && finalChild && finalChildOfChild){
          for (var x = 0; x < finalParent.length; x++) {
            formData.append("parent[]", finalParent[x]);
          }
          // formData.append("child", JSON.stringify(finalChild));
          for (var x = 0; x < finalChild.length; x++) {
            formData.append("child[]", finalChild[x]);
          }
          // formData.append("sub_child", JSON.stringify(finalChildOfChild));
          for (var x = 0; x < finalChildOfChild.length; x++) {
            formData.append("sub_child[]", finalChildOfChild[x]);
          }
          for (var x = 0; x < this.attachment.galleries.length; x++) {
            formData.append("image" + x, this.attachment.galleries[x]);
          }
      }
      // var count = this.attachment.galleries.length;
      // formData.append("image_count", count);

      // formData.append('image', ImageArray)
      // var files=this.attachment.galleries
      // var myArray=[]
      // for(var i = 0; i < files.length; i++){
      //   var file = {
      //     'lastMod'    : files[i].lastModified,
      //       'lastModDate': files[i].lastModifiedDate,
      //       'name'       : files[i].name,
      //       'size'       : files[i].size,
      //       'type'       : files[i].type,
      //   }
      //   myArray.push(file)
      // }
      // console.log(myArray);

      // formData.append('image', myArray)

      // Object.keys(moduleDetails).forEach(key => formData.append(key, moduleDetails[key]));
      console.log(formData);
        const config = {
          headers: {
              'content-type': 'multipart/form-data'
          }
        }
        api.postData('admin/module/create', formData,config).then(res => {
          console.log(res)
              if(res.status==201){
                  this.loading=false
                  this.alert.type="success"
                  this.alert.msg="Class Created Successfully"
                  setTimeout(() => {
                    this.$router.push("/classes");
                  }, 1000);
              }
        }).catch((error) => {
            console.log(error)
            this.loading=false
            this.alert.type="warning"
            this.alert.msg="Class not created"
        })
      // this.$store.dispatch("Modules/AddModule", formData).then(res => {
      //   console.log(res);
      //   this.loading=false
      //   this.alert.type="success"
      //   this.alert.msg="Class Created Successfully"
      //   setTimeout(() => {
      //     this.$router.push("/classes");
      //   }, 1000);
      // }).catch(error=>{
      //   console.log(error)
      //   this.loading=false
      //   this.alert.type="warning"
      //   this.alert.msg="Class not created"
      // });
    },
    // onPickImg() {
    //   this.$refs.ImgInput.click();
    // },
    // onImgPicked() {
    //   const files = event.target.files;
    //   console.log(files);
    //   if (files.length == 1) {
    //     console.log(files[0]);
    //     this.attachment.galleries.push(files[0]);
    //   } else {
    //     for (var i = 0; i < files.length; i++) {
    //       this.attachment.galleries.push(files[i]);
    //     }
    //   }
    //   for (var i = 0; i < files.length; i++) {
    //     let fileName = files[i].name;
    //     if (fileName.lastIndexOf(".") <= 0) {
    //       return alert("Please add a valid file! ");
    //     }
    //     console.log(fileName);
    //   }
    //   for (var i = 0; i < files.length; i++) {
    //     const fileReader = new FileReader();
    //     fileReader.readAsDataURL(files[i]);
    //     // console.log(fileName)
    //     // var fileName
    //     fileReader.addEventListener("load", () => {
    //       this.attachment.galleryURL.push(fileReader.result);
    //       // console.log( this.attachment.galleryURL);
    //     });
    //   }

    //   console.log(this.attachment);
    // }
  },
  components: {
    ConfirmSignup,
    Treeselect
  }
};
</script>
<style>
.v-dialog {
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/classes/CreateClass.vue